/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class TextAreaEditor extends BaseFieldEditor {
	@autobind
	_render() {
		return <FormControl
			as="textarea"
			value={this.props.Value == null ? "" : this.props.Value}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
			placeholder={this.props.FieldDef.placeholder}
		/>;
	}
}